import { memo } from 'react';
import { useTheme } from '@mui/material';
import QualificationBaselineValidationIllustrationLight from './qualificationBaselineValidation.svg?react';
import QualificationBaselineValidationIllustrationDark from './qualificationBaselineValidation_dark.svg?react';

export const QualificationBaselineValidationIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return (
        <QualificationBaselineValidationIllustrationDark
          aria-hidden="true"
          {...props}
        />
      );
    return (
      <QualificationBaselineValidationIllustrationLight
        aria-hidden="true"
        {...props}
      />
    );
  },
);
